import imageCompression from 'browser-image-compression';

export const capitalizeWords = (str) => {
  return str
    .split(' ') 
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export const compressImageWebp = async (file) => {
  const compressOption = {
    maxSizeMB: 0.6,
    fileType: 'image/webp',
    initialQuality: 1,
  }

  const compresedImage = await imageCompression(file, compressOption);
  const originalName = file.name; 
  const baseName = originalName.substring(0, originalName.lastIndexOf('.')) || originalName;
  const newFileName = baseName + '.webp';

  return new File([compresedImage], newFileName, { type: 'image/webp' });
}

export function base64ToFile(base64String, fileName, mimeType) {
  const byteString = atob(base64String.split(",")[1] || base64String); 
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], fileName, { type: mimeType });
}

export async function imageUrlToFile(url, fileName) {
  const response = await fetch(url, { mode: "cors" }); // CORS must be allowed
  const blob = await response.blob();
  const mimeType = blob.type || "image/png"; // fallback if unknown

  return new File([blob], fileName, { type: mimeType });
}